export const CLOSE_MODAL = 'contextList/CLOSE_MODAL';
export const CONTEXT_CLICKED = 'contextList/CONTEXT_CLICKED';
export const OPEN_MODAL = 'contextList/OPEN_MODAL';
export const RESET_CONTEXT_LIST = 'contextList/RESET_CONTEXT_LIST';
export const SET_SELECTED_CONTEXTS = 'contextList/SET_SELECTED_CONTEXTS';
